import {
  loopbackGet,
  loopbackPost,
  loopbackPut,
  loopbackDelete,
} from '..';
import { BACKEND_URL } from '../../environment';
import { GroundTruth } from '../../redux/types';

export const backendUrl = BACKEND_URL;

export const getGroundTruths = (filter: any): Promise<GroundTruth[]> => loopbackGet(`GroundTruths?filter=${JSON.stringify(filter)}`);

export const createGroundTruth = (data: Omit<GroundTruth, 'id'>): Promise<GroundTruth> => loopbackPost('GroundTruths', data);

/**
* @param {number} groundTruthId
* @param {GroundTruth} groundTruthData
*/
export const updateGroundTruth = (groundTruthId: number, groundTruthData: Omit<GroundTruth, 'id'>): Promise<GroundTruth> => loopbackPut(`GroundTruths/${groundTruthId}`, groundTruthData);

export const deleteGroundTruth = (id: number): Promise<unknown> => loopbackDelete(`GroundTruths/${id}`);
